<template>
  <el-dialog
    title="更新供应商"
    :visible.sync="dialogFormVisible"
    width="550px"
    @close="closeUpdateDialog"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="140px">
      <el-form-item label="供应商名称" prop="sellerName">
        <el-select
          v-model="form.sellerName"
          filterable
          default-first-option
          placeholder="请选择供应商名称"
          @change="handleSupplierChange"
        >
          <el-option
            v-for="(item, index) in supplierOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="供应商代码" prop="sellerCode">
        <el-input
          v-model="form.sellerCode"
          autocomplete="off"
          placeholder=""
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item label="供应商税号" prop="sellerTaxnum">
        <el-input
          v-model.trim="form.sellerTaxnum"
          autocomplete="off"
          placeholder=""
          disabled
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeUpdateDialog">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "UpdateSupplier",
  data() {
    return {
      form: {
        sellerCode: "",
        sellerTaxnum: "",
        sellerName: "",
        ids: [],
      },
      supplierOptions: [],
      dialogFormVisible: false,
    };
  },
  created() {},
  methods: {
    /**
     * @description 显示更新供应商对话框
     */
    showUpdateDialog(ids) {
      this.dialogFormVisible = true;
      this.form.ids = ids;
      this.fetchSupplierList();
    },

    /**
     * @description 获取对比发票池供应商列表
     */
    async fetchSupplierList() {
      const { userId } = this.$route.query;
      this.$api
        .post("/input/grn/supplierNameQuery", { userId: userId })
        .then((res) => {
          this.supplierOptions = res.data;
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },

    /**
     * @description 供应商名称改变事件
     */
    handleSupplierChange(sellerName) {
      if (!sellerName) {
        this.form.sellerCode = "";
        this.form.sellerTaxnum = "";
        return;
      }

      const { userId } = this.$route.query;
      this.$api
        .post("/input/income-pool-invoice-basic-info-new/queryListSuppliers", {
          userId: userId,
          sellerName: sellerName,
        })
        .then((res) => {
          console.log("供应商信息", res);
          if (res.data && res.data.length > 0) {
            const supplierInfo = res.data[0];
            this.form.sellerCode = supplierInfo.supplier || "";
            this.form.sellerTaxnum = supplierInfo.taxRegnNum || "";
          } else {
            this.form.sellerCode = "";
            this.form.sellerTaxnum = "";
          }
        })
        .catch((err) => {
          console.log("err", err);
          this.$message.error(err.message);
        });
    },

    /**
     * @description 关闭新增/编辑对话框
     */
    closeUpdateDialog() {
      this.$refs["form"].resetFields();
      this.form = this.$options.data().form;
      this.dialogFormVisible = false;
    },

    /**
     * @description 保存
     */
    async save() {
      this.$refs["form"].validate(async (valid) => {
        if (!valid) {
          return false;
        }

        const { userId } = this.$route.query;

        // 发起请求，提交表单数据
        this.$api
          .post(
            "/input/income-pool-invoice-basic-info-new/batchUpdateSupplierBasicInfo",
            { ...this.form, userId: userId },
          )
          .then((res) => {
            console.log("res", res);
            this.$message.success("更新供应商成功");
            // 请求成功后触发 fetch-data 事件并关闭编辑窗口
            const { searchData } = this.$store.state.CompareInvoicePool;
            this.$emit("fetch-data", searchData);
            this.$emit("clear-selected");
            this.closeUpdateDialog();
          })
          .catch((err) => {
            this.$message.error(err.message);
            this.closeUpdateDialog();
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}
</style>
